// Angular:
import { InjectionToken } from '@angular/core';

import { StepIndicatorItemComponent } from '../step-indicator-item/step-indicator-item.component';

export interface IStepIndicatorComponent {
    moveBack(): void;

    moveForward(): void;

    select(item: StepIndicatorItemComponent): void;
}

export const stepIndicatorComponentInjection: InjectionToken<IStepIndicatorComponent> = new InjectionToken<IStepIndicatorComponent>(
    'stepIndicatorComponentInjection'
);
